import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    const timeout = setTimeout(() => {
      requestAnimationFrame(() => { 
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
 
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0; 
        const root = document.getElementById("root");
        if (root) root.scrollTop = 0;
      });
    }, 500);

    return () => clearTimeout(timeout);
  }, [pathname]);

  return children;
};

export default ScrollToTop;
